import { APIFieldAttributes } from '@ardoq/api-types';
import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale, t } from '@ardoq/i18n';
import { getDefaultFiltersBySearchContext } from './const';
import { isExclusivelyPerspectivesOperator, SearchContext } from '../types';
import { QueryBuilderFilterDefinitionGroup } from './types';
import { composeFiltersFromFields } from './composeFiltersFromFields';

const groupWithNonEmptyFilters = (
  filterGroup: QueryBuilderFilterDefinitionGroup
) => {
  return Boolean(filterGroup.filters.length);
};

export const composeAdvancedSearchFilterGroups = (
  searchContext: SearchContext,
  fields: APIFieldAttributes[],
  i18nLocale: I18nLocale = DEFAULT_ARDOQ_I18NLOCALE
): QueryBuilderFilterDefinitionGroup[] => {
  const defaultFilters = getDefaultFiltersBySearchContext(i18nLocale)[
    searchContext
  ].map(f => ({
    ...f,
    operators: f.operators.filter(
      operator => !isExclusivelyPerspectivesOperator(operator)
    ),
  }));

  const fieldFilters = composeFiltersFromFields(fields, searchContext, false);
  return [
    {
      label: t(i18nLocale, 'queryBuilder:filterGroup.default', 'Default'),
      filters: defaultFilters,
    },
    {
      label: t(
        i18nLocale,
        'queryBuilder:filterGroup.customFields',
        'Custom fields'
      ),
      filters: fieldFilters,
    },
  ].filter(groupWithNonEmptyFilters);
};
